module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAZCAYAAABzVH1EAAAAAXNSR0IArs4c6QAAAKRJREFUWAnV1j0OgCAMhuE2emsdOJreRE+CdQRC+IevJB3K9D5MMJ32IaKLWGaTMfzv6g7TYa1TzfTKrg4WQhyVLEpgaYgSWDkEFNYOAYH1hyyCjYdMgs2HDIKth3SC4UEqYfiQTJg+SAi75crs/j38Hvky4UMi4f6D40Eyw/EgleHrIZ3C50MGhY+HTArvD1kU3g4BCS+HgIanIUrCQ4jScB/yAdx9jU0MIkBkAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/cursor-right.png
// module id = 1xp8
// module chunks = 1